export const MISSION_AREAS = [
  {
    value: 1,
    name: "Education",
    description:
      "Create upward mobility by improving access to high quality, low cost education.",
  },
  {
    value: 2,
    name: "Poverty",
    description:
      "Support people living in poverty and eliminate the root causes of financial instability.",
  },
  {
    value: 3,
    name: "Sustainability",
    description:
      "Secure the future of the planet through sustainable practices.",
  },
  {
    value: 4,
    name: "Renewable energy",
    description: "Accelerate the transition to green energy technology.",
  },
  {
    value: 5,
    name: "Diversity, equity, and inclusion",
    description:
      "Create a world where everyone has the opportunity to live a fulfilling life.",
  },
  {
    value: 6,
    name: "Public safety",
    description: "Protect and secure the lives of individuals and communities.",
  },
  {
    value: 7,
    name: "Health and wellness",
    description:
      "Drive healthcare efficiency and improve personal health and wellness.",
  },
  {
    value: 8,
    name: "Nourishment",
    description:
      "Produce food and beverages with positive social and environmental impact.",
  },
  {
    value: 9,
    name: "Transportation",
    description:
      "Develop the future of transportation and the infrastructure that enables it.",
  },
];

export const getNewMailchimpTags = (oldTags, missionAreas) => {
  // Merges the existing account tags with the new mission areas

  // Convert mission areas to tags
  const missionAreaTags = missionAreas.map((area) => `M${area}`);

  // Combine tags
  let newTags;
  if (oldTags === undefined || oldTags.length === 0) {
    newTags = missionAreaTags;
  } else {
    // Remove mission areas from old tags before merging
    const filteredOldTags = oldTags.filter((tag) => tag[0] !== "M");

    newTags = [...filteredOldTags, ...missionAreaTags];
  }

  // Remove duplicates and return
  return [...new Set(newTags)];
};
